import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Labeled, useRecordContext, RecordContextProvider, TextField, } from 'react-admin';
import { Stack } from '@mui/material';
import get from 'lodash/get';
import { InsDel } from './InsDel';
import { useReferenceRecordContext } from '../ReferenceRecordContext';
/**
 * Displays the diff of a given field.
 *
 * When used with no child, `<FieldDiff>` displays the diff using a `<TextField>`.
 *
 * `<FieldDiff>` must be used in a `diff` element, for instance in `<RevisionsButton>`.
 *
 * @example
 * import { FieldDiff } from '@react-admin/ra-history';
 * import { Edit, NumberField } from 'react-admin';
 * import { Stack } from '@mui/material';
 *
 * export const ProductDiff = () => (
 *     <Stack gap={1}>
 *         <FieldDiff source="reference" />
 *         <FieldDiff source="description" />
 *         <FieldDiff inline>
 *             <NumberField source="stock" />
 *         </FieldDiff>
 *     </Stack>
 * );
 *
 * const ProductEditActions = () => (
 *     <TopToolbar>
 *          <RevisionsButton diff={<ProductDiff />} />
 *     </TopToolbar>
 * );
 */
export var FieldDiff = function (_a) {
    var source = _a.source, children = _a.children, label = _a.label, inline = _a.inline, sx = _a.sx;
    var record = useRecordContext();
    var referenceRecord = useReferenceRecordContext();
    var finalChild = children || (source ? _jsx(TextField, { source: source }) : undefined);
    var finalSource = source ||
        (children === null || children === void 0 ? void 0 : children.props.source);
    if (!finalChild || !finalSource) {
        throw new Error('Missing source prop when using <FieldDiff>. Pass the field name as the source prop, or render a Field component as child.');
    }
    var hasDifference = get(record, finalSource) !== get(referenceRecord, finalSource);
    return (_jsx(InsDel, { sx: sx, children: hasDifference ? (_jsx(Labeled, { source: finalSource, label: label, children: inline ? (_jsxs(Stack, { direction: "row", sx: {
                    gap: 0.5,
                }, children: [_jsx("ins", { children: finalChild }), _jsx(RecordContextProvider, { value: referenceRecord, children: _jsx("del", { children: finalChild }) })] })) : (_jsxs(_Fragment, { children: [_jsx("span", { children: _jsx("ins", { children: finalChild }) }), _jsx("span", { children: _jsx(RecordContextProvider, { value: referenceRecord, children: _jsx("del", { children: finalChild }) }) })] })) })) : (_jsx(Labeled, { source: source, label: label, children: finalChild })) }));
};
